
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weddings/contact",
      function () {
        return require("private-next-pages/weddings/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weddings/contact"])
      });
    }
  